/**
 * State used by graph views that provide an already-known set of inferred
 * relationships instead of discovering them from the live relationship
 * registry.
 */

import { atom, type PrimitiveAtom } from 'jotai';

import type { RelationshipInfo } from '../services/cypherQueryService';

export type InferenceRelationshipOverride = {
	outgoing: RelationshipInfo[];
	incoming: RelationshipInfo[];
};

export type InferenceRelationshipOverrides = Record<string, InferenceRelationshipOverride>;

/**
 * Optional relationship data supplied by an inferred-detail graph. The
 * generic Explorer keeps this unset, so inferred relationships remain
 * excluded from normal live discovery.
 */
export const InferenceRelationshipOverridesAtom: PrimitiveAtom<InferenceRelationshipOverrides | null> & {
	init: InferenceRelationshipOverrides | null;
} = atom<InferenceRelationshipOverrides | null>(null);
